export default __webpack_public_path__ + "static/media/iot-marketplace.1ee5c200.png";